import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  saveVersionRequest,
  saveVersionSuccess,
  saveVersionFailure,
} from '../reducers/savedVersions';
import { API_LINK } from '../../constants';
import { getUserProgramsFullRequest } from '../reducers/userProgramsFull';

const API = `${API_LINK}api/version`;

function* saveVersionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const {
    selectedContentId: thinktoolId,
    // selectedVersionId: versionId,
  } = state.userProgramsFullReducer;
  var name
  try {
    name = (!state.form || !state.form.saveEdit.values)
    ? state.savedVersionsReducer.learnerVersions.find(
        version => version.versionId === state.userProgramsFullReducer.selectedUserVersion,
      ).name
    : state.form.saveEdit.values.versionName;
  } catch (error) {
    
  }
 

  const { pathToSaveVersion: pathToVersion } = state.savedVersionsReducer;
  if(!name){
    name=thinktoolId
  }
  console.log('JOURNAL MESSAGE3', name, pathToVersion,thinktoolId, userId)
  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        userId,
        thinktoolId,
        name,
        pathToVersion,
      },
    }),
  );

  return response;
}

function* workerSaveVersionSaga() {
  try {
    const response = yield call(saveVersionAxios);

    const responseFromSaveVersion = response.data;
    console.log('JOuRNAL MESSAGE ERR', responseFromSaveVersion)
    if (response.status === 200) {
      yield put(saveVersionSuccess(responseFromSaveVersion));
      yield put(getUserProgramsFullRequest());
    }
    if (response.status === 201) {
      yield put(saveVersionFailure(responseFromSaveVersion));
    }
    if (response.status === 500) {
      yield put(saveVersionFailure(response.statusText));
    }
    if (response.status === 207) {
      yield put(saveVersionFailure(responseFromSaveVersion));
    }
  } catch (error) {
    console.log('JOuRNAL MESSAGE ERR', error)
    yield put(saveVersionFailure(error));
  }
}

export function* watcherSaveVersionSaga() {
  yield takeLatest(saveVersionRequest().type, workerSaveVersionSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_version.js